import nav_building_01 from './nav-building-01.svg';
import nav_building_02 from './nav-building-02.svg';
import nav_building_03 from './nav-building-03.svg';
import nav_building_04 from './nav-building-04.svg';
import nav_car_auto from './nav-car-auto.svg';
import nav_compass from './nav-compass.svg';
import nav_flag from './nav-flag.svg';
import nav_globe from './nav-globe.svg';
import nav_house_01 from './nav-house-01.svg';
import nav_house_03 from './nav-house-03.svg';
import nav_house_02 from './nav-house-2.svg';
import nav_house_add from './nav-house-add.svg';
import nav_house_check from './nav-house-check.svg';
import nav_house_close from './nav-house-close.svg';
import nav_house_remove from './nav-house-remove.svg';
import nav_map from './nav-map.svg';
import nav_map_pin from './nav-map-pin.svg';
import nav_navigation from './nav-navigation.svg';
import nav_account_filled from './nav_account_2.svg';
import nav_account from './nav_account.svg';
import nav_acct_button_default from './nav_acct_button_default.svg';
import nav_acct_button_disabled from './nav_acct_button_disabled.svg';
import nav_acct_button_hover from './nav_acct_button_hover.svg';
import nav_acct_button_selected from './nav_acct_button_selected.svg';
import nav_antimalware_filled from './nav_antimalware_selected.svg';
import nav_antimalware from './nav_antimalware.svg';
import nav_credit_darkweb_filled from './nav_credit_darkweb_selected.svg';
import nav_credit_darkweb from './nav_credit_darkweb.svg';
import nav_files_filled from './nav_files_selected.svg';
import nav_files from './nav_files.svg';
import nav_hamburger_close from './nav_hamburger_close.svg';
import nav_hamburger_default from './nav_hamburger_default.svg';
import nav_help_filled from './nav_help_selected.svg';
import nav_help from './nav_help.svg';
import nav_home_filled from './nav_home_2.svg';
import nav_home from './nav_home.svg';
import nav_inbox_filled from './nav_inbox_2.svg';
import nav_inbox from './nav_inbox.svg';
import nav_more_filled from './nav_more_2.svg';
import nav_more from './nav_more.svg';
import nav_overview_filled from './nav_overview_2.svg';
import nav_overview from './nav_overview.svg';
import nav_passwords_filled from './nav_passwords_selected.svg';
import nav_passwords from './nav_passwords.svg';
import nav_products_menu_filled from './nav_products_menu_2.svg';
import nav_products_menu from './nav_products_menu.svg';
import nav_profile_filled from './nav_profile_2.svg';
import nav_profile from './nav_profile.svg';
import nav_reputation_filled from './nav_reputation_selected.svg';
import nav_reputation from './nav_reputation.svg';
import nav_requests_filled from './nav_requests_selected.svg';
import nav_requests from './nav_requests.svg';
import nav_settings_filled from './nav_settings_2.svg';
import nav_settings from './nav_settings.svg';
import nav_signout_filled from './nav_signout_selected.svg';
import nav_signout from './nav_signout.svg';
import nav_vpn_filled from './nav_vpn_selected.svg';
import nav_vpn from './nav_vpn.svg';

export const V2_NAVIGATION_ICONS: { [char: string]: string } = {
  nav_account,
  nav_account_filled,
  nav_acct_button_default,
  nav_acct_button_disabled,
  nav_acct_button_hover,
  nav_acct_button_selected,
  nav_antimalware,
  nav_antimalware_filled,
  nav_building_01,
  nav_building_02,
  nav_building_03,
  nav_building_04,
  nav_car_auto,
  nav_compass,
  nav_credit_darkweb,
  nav_credit_darkweb_filled,
  nav_files,
  nav_files_filled,
  nav_flag,
  nav_globe,
  nav_hamburger_close,
  nav_hamburger_default,
  nav_help,
  nav_help_filled,
  nav_home,
  nav_home_filled,
  nav_house_01,
  nav_house_02,
  nav_house_03,
  nav_house_add,
  nav_house_check,
  nav_house_close,
  nav_house_remove,
  nav_inbox,
  nav_inbox_filled,
  nav_map,
  nav_map_pin,
  nav_more,
  nav_more_filled,
  nav_navigation,
  nav_overview,
  nav_overview_filled,
  nav_passwords,
  nav_passwords_filled,
  nav_products_menu,
  nav_products_menu_filled,
  nav_profile,
  nav_profile_filled,
  nav_reputation,
  nav_reputation_filled,
  nav_requests,
  nav_requests_filled,
  nav_settings,
  nav_settings_filled,
  nav_signout,
  nav_signout_filled,
  nav_vpn,
  nav_vpn_filled,
};

export const V2_NAVIGATION_ICON_NAMES: string[] = Object.keys(V2_NAVIGATION_ICONS);
